import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import shareVoteImage from "@assets/images/share_vote.png";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Person } from "@domain/user/user";
import { fullName } from "@domain/user/utils";
import { Primary } from "@ui/components/containers/primary";
import { ShareOnSocialMedia } from "@ui/components/shareOnSocialMedia";
import { ClosableModal } from "@ui/modals/closableModal";
interface ShareProfileModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
	canonicalLink: string;
	person?: Person;
}
export const ShareProfileModale: React.FC<ShareProfileModalProps> = ({
	canonicalLink,
	person,
	close,
	...htmlProps
}) => {
	const currentProfile = useCurrentProfile();
	const isMe = !!currentProfile && person?.id === currentProfile.id;
	return (
		<Container close={close} {...htmlProps}>
			<ContainerLabel>
				<img src={shareVoteImage} width="118px" height="107px" />
				<Primary>
					<ShareText>
						<b>{I18n.t("vote.popin.share.label")}</b>
					</ShareText>
				</Primary>
			</ContainerLabel>
			<ContainerIcon>
				{person ? (
					<ShareOnSocialMedia
						message={I18n.t(isMe ? "vote.share.my-profile.message" : "vote.share.profile.message", {
							name: fullName(person),
						})}
					/>
				) : null}
			</ContainerIcon>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const ContainerIcon = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 50px;
`;

const ContainerLabel = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const ShareText = styled.div`
	font-style: normal;
	font-size: 24px;
	margin-top: 16px;
`;
